import { useKeycloak } from "@react-keycloak/web";
import { Button, Form, Input } from "antd";
import { useEffect, useState } from "react";

import { useAppSelector } from "../../../app/store";
import CustomModal from "../../../components/ui/CustomModal";
import Loader from "../../../components/ui/Loader";
import {
  useCreateWalletMutation,
  useGetAllWalletTagQuery,
  useGetSingleWalletQuery,
  useUpdateWalletMutation,
  useUpdateWalletV2Mutation,
} from "../../../features/portal/companyOnboard/companyOnboardApi";
import {
  useOtpRequestTimeQuery,
  useReSendOtpMutation,
  useSendOtpMutation,
} from "../../../features/portal/vendorPayment/vendorPaymentApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  type?: "ADD" | "UPDATE";
  isApprover?: string;
};

const OTP_EXPIRY_SECONDS = 180;

export default function AddWalletModal({
  open,
  handleClose,
  data,
  type,
  isApprover,
}: Props) {
  const [form] = Form.useForm();
  const { keycloak } = useKeycloak();
  const token = keycloak?.token;
  const [addedWallet, setAddedWallet] = useState(false);
  const [walletNumber, setWalletNumber] = useState("");
  const [walletName, setWalletName] = useState("");
  const [tagIds, setTagIds] = useState<any[]>([]);
  const [currentTime, setCurrentTime] = useState<string>(
    new Date().toISOString()
  );
  const [remaining, setRemaining] = useState(OTP_EXPIRY_SECONDS);
  const [tagOptions, setTagOptions] = useState<any[]>([]);
  const [sendOtp, { isError, error, isLoading, isSuccess, data: otpData }] =
    useSendOtpMutation();
  const [
    reSendOtp,
    {
      isError: reSendOtpIsError,
      error: reSendOtpError,
      isLoading: reSendOtpIsLoading,
      isSuccess: reSendOtpIsSuccess,
    },
  ] = useReSendOtpMutation();
  const {
    data: otpRequestTimeData,
    isError: otpRequestTimeIsError,
    error: otpRequestTimeError,
    refetch: otpRequestTimeRefatch,
  } = useOtpRequestTimeQuery(token);
  const { user } = useAppSelector((state) => state.auth);
  const [
    updateWallet,
    {
      isError: isWalletError,
      error: walletError,
      isLoading: isWalletLoading,
      isSuccess: isWalletSuccess,
      //   data: walletData,
    },
  ] = useUpdateWalletMutation();

  const {
    data: getAllWalletTagData,
    isError: getAllWalletTagIsError,
    error: getAllWalletTagError,
  } = useGetAllWalletTagQuery({
    params: {
      page: 1,
      limit: 100000000,
    },
  });

  const [
    createWallet,
    {
      isError: createWalletIsError,
      error: createWalletError,
      isSuccess: createWalletIsSuccess,
    },
  ] = useCreateWalletMutation();

  const [
    updateWalletV2,
    {
      isError: updateWalletV2IsError,
      error: updateWalletV2Error,
      isSuccess: updateWalletV2IsSuccess,
    },
  ] = useUpdateWalletV2Mutation();

  const {
    data: getSingleWalletData,
    isError: getSingleWalletIsError,
    error: getSingleWalletError,
    isLoading: getSingleWalletIsLoading,
  } = useGetSingleWalletQuery(data, { skip: !data });

  useError(isError, error, "OTP send fail");
  useError(isWalletError, walletError, "Wallet update fail");
  useError(
    otpRequestTimeIsError,
    otpRequestTimeError,
    "Get OTP request time fail"
  );
  useError(reSendOtpIsError, reSendOtpError, "OTP resend fail");
  useError(getAllWalletTagIsError, getAllWalletTagError, "Get wallet tag fail");
  useError(createWalletIsError, createWalletError, "Wallet create fail");
  useError(updateWalletV2IsError, updateWalletV2Error, "Wallet update fail");
  useError(
    getSingleWalletIsError,
    getSingleWalletError,
    "Get single wallet data fail"
  );

  let deviceId = localStorage.getItem("device_id");

  const onFinish = (values: any) => {
    setWalletNumber(values?.wallet_number);
    setWalletName(values?.wallet_name);
    // setTagIds(values?.tag_ids);
    sendOtp({
      body: {
        Username: values?.wallet_number,
        FullName: "SP1A.210812.016",
        App_Version: "4.1.0",
        Phone_Brand: "itel S665L",
        Phone_Os: "android",
        Os_Version: "12",
        LANG: "bn",
        Device_Id: deviceId,
      },
    });
  };
  const onFinish2 = (values: any) => {
    updateWallet({
      companyId: user?.data?.company_id,
      OTP: values?.OTP,
      sourceWallet: walletNumber,
      Username: walletNumber,
      App_Version: "4.1.0",
      Device_Id: deviceId,
      Device_Password: otpData?.data?.data?.Password,
      FullName: "SP1A.210812.016",
      LANG: "bn",
      Os_Version: "12",
      Phone_Brand: "itel S665L",
      Phone_Os: "android",
    });
  };

  // const handleChangeTags = async (values: (string | number)[]) => {
  //   const lastValue = values[values.length - 1];
  //   if (!lastValue) return; // nothing to do

  //   // If lastValue is NOT a string => user selected an existing option (value is id)
  //   if (typeof lastValue !== "string") return;

  //   const normalizedInput = lastValue.trim().toLowerCase();

  //   // case-insensitive check against option labels
  //   const exists = tagOptions.some(
  //     (option) =>
  //       String(option.label || "")
  //         .trim()
  //         .toLowerCase() === normalizedInput
  //   );

  //   if (exists) {
  //     // optional: give user feedback
  //     toast("warning", "This tag already exists");
  //     return; // do NOT call API
  //   }

  //   try {
  //     const response = await createWalletTag({ name: lastValue }).unwrap();
  //     const newTag = {
  //       label: response.name,
  //       value: response.id,
  //     };
  //     setTagOptions((prev) => [...prev, newTag]);
  //   } catch (err) {
  //     toast("error", "Failed to create tag");
  //   }
  // };

  // useEffect(() => {
  //   if (getAllWalletTagData?.data?.length) {
  //     const formattedTags = getAllWalletTagData.data.map((item: any) => ({
  //       label: item.name,
  //       value: item.id,
  //     }));
  //     setTagOptions(formattedTags);
  //   }
  // }, [getAllWalletTagData]);

  useEffect(() => {
    if (type === "UPDATE" && getSingleWalletData?.data) {
      form.setFieldsValue({
        wallet_number: getSingleWalletData?.data?.wallet_number,
        wallet_name: getSingleWalletData?.data?.wallet_name,
        tag_ids: getSingleWalletData?.data?.tags?.map((tag: any) => tag.id),
      });
      setWalletNumber(getSingleWalletData?.data?.wallet_number);
      setWalletName(getSingleWalletData?.data?.wallet_name);
      // setTagIds(getSingleWalletData?.data?.tags?.map((tag: any) => tag.id));
    }
  }, [getSingleWalletData?.data, form, type]);

  useEffect(() => {
    if (isSuccess) {
      toast("success", "OTP send successfully");
      setAddedWallet(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    const newData = {
      wallet_number: walletNumber,
      wallet_name: walletName,
      // tag_ids: tagIds,
    };

    if (
      isWalletSuccess &&
      walletNumber &&
      walletName &&
      // tagIds &&
      type === "UPDATE" &&
      data
    ) {
      // handleClose();

      updateWalletV2({
        data: newData,
        id: data,
      });
    } else if (
      isWalletSuccess &&
      walletNumber &&
      walletName &&
      // tagIds &&
      type === "ADD"
    ) {
      createWallet(newData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWalletSuccess, walletNumber, walletName, type]);

  useEffect(() => {
    if (createWalletIsSuccess) {
      handleClose();
      setWalletNumber("");
      setWalletName("");
      // setTagIds([]);
      form.resetFields();
      toast("success", "Wallet added successfully");
    }
  }, [createWalletIsSuccess, form, handleClose]);

  useEffect(() => {
    if (updateWalletV2IsSuccess) {
      handleClose();
      setWalletNumber("");
      setWalletName("");
      // setTagIds([]);
      form.resetFields();
      toast("success", "Wallet updated successfully");
    }
  }, [updateWalletV2IsSuccess, form, handleClose]);

  useEffect(() => {
    const timer = setInterval(() => {
      // always store UTC string
      setCurrentTime(new Date().toISOString());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!isSuccess) {
      setRemaining(OTP_EXPIRY_SECONDS); // reset when not success
      return;
    }

    setRemaining(OTP_EXPIRY_SECONDS); // start from 3 min 00 sec
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isSuccess]);

  useEffect(() => {
    if (!reSendOtpIsSuccess) {
      setRemaining(OTP_EXPIRY_SECONDS); // reset when not success
      return;
    }

    setRemaining(OTP_EXPIRY_SECONDS); // start from 3 min 00 sec
    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [reSendOtpIsSuccess]);

  // format mm:ss
  const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
  const seconds = String(remaining % 60).padStart(2, "0");

  const lastOtpTime = new Date(otpRequestTimeData?.data?.lastOtpRequestedAt);
  const expiryTime = new Date(lastOtpTime.getTime() + 3 * 60 * 1000);
  const newCurrentTime = new Date(currentTime);

  // difference in milliseconds
  const diffMs = expiryTime.getTime() - newCurrentTime.getTime();

  // convert to minutes & seconds
  const diffMinutes = Math.floor(diffMs / 1000 / 60);
  const diffSeconds = Math.floor((diffMs / 1000) % 60);

  const label = seconds === "00" ? `OTP` : `OTP ${minutes}:${seconds}`;

  // console.log(`Remaining: ${diffMinutes}m ${diffSeconds}s`);

  // console.log("expiryTime:", expiryTime);
  // console.log("Current time:", newCurrentTime);

  const handleResendOtp = () => {
    if (walletNumber) {
      reSendOtp({
        body: {
          Username: walletNumber,
          FullName: "SP1A.210812.016",
          App_Version: "4.1.0",
          Phone_Brand: "itel S665L",
          Phone_Os: "android",
          Os_Version: "12",
          LANG: "bn",
          Device_Id: deviceId,
        },
      });
    }
  };

  const validateMobileBankAccount = async (_: any, value: string) => {
    if (!value) {
      return Promise.resolve();
    }

    // Step 1: only digits
    const digitsOnlyRegex = /^\d+$/;
    if (!digitsOnlyRegex.test(value)) {
      return Promise.reject(
        new Error("Wallet number must contain only digits")
      );
    }

    // Step 2: allow either 11 digits or 13 digits with '88' prefix
    let normalized = value;
    if (value.startsWith("88")) {
      if (value.length !== 13) {
        return Promise.reject(
          new Error("Wallet number with country code must be 13 digits")
        );
      }
      normalized = value.slice(2); // remove 88 prefix for further checks
    } else if (value.length !== 11) {
      return Promise.reject(new Error("Wallet number must be 11 digits"));
    }

    // Step 3: must start with valid BD mobile operator code
    const validOperators = /^01[3-9]/;
    if (!validOperators.test(normalized)) {
      return Promise.reject(
        new Error("Please enter a valid Bangladeshi number")
      );
    }

    return Promise.resolve();
  };

  const normalizeMobileBankAccount = (value: string | undefined) => {
    // Check if the value exists and is exactly 11 characters long
    if (
      value &&
      value.length === 11 &&
      // Check if it only contains digits
      /^\d+$/.test(value) &&
      // Ensure it doesn't already start with '88' to prevent '8888...'
      !value.startsWith("88")
    ) {
      // Prepend '88'
      return "88" + value;
    }
    // Return the value unchanged otherwise (e.g., if null, empty, 13 digits, or invalid format)
    return value;
  };

  useEffect(() => {
    if (reSendOtpIsSuccess) {
      toast("success", "OTP resend successfully");
      otpRequestTimeRefatch();
    }
  }, [reSendOtpIsSuccess, otpRequestTimeRefatch]);

  return (
    <CustomModal
      title={
        addedWallet ? "OTP" : type === "ADD" ? "Add Wallet" : "Update Wallet"
      }
      open={open}
      handleClose={handleClose}
      footer={null}
    >
      {addedWallet ? (
        <>
          {minutes === "00" && seconds === "00" ? (
            <>
              <div className="flex justify-center mt-2">
                <Button
                  type="primary"
                  className="min-w-36"
                  size="middle"
                  onClick={handleResendOtp}
                  loading={reSendOtpIsLoading}
                >
                  Resend OTP
                </Button>
              </div>
            </>
          ) : (
            <Form
              name="form_item_path"
              className="custom-form"
              layout="vertical"
              onFinish={onFinish2}
              requiredMark="optional"
              size="large"
              // form={form}
            >
              <Form.Item
                label={
                  (isSuccess && remaining > 0) ||
                  (reSendOtpIsSuccess && remaining > 0) ? (
                    <span>{label}</span>
                  ) : null
                }
                name="OTP"
                rules={[
                  {
                    required: true,
                    message: "Please enter OTP",
                  },
                  {
                    pattern: /^\d{6,}$/,
                    message: "OTP must be at least 6 digits",
                  },
                ]}
              >
                <Input placeholder="Enter OTP" />
              </Form.Item>
              <div className="flex justify-center mt-2">
                <Button
                  type="primary"
                  className="min-w-36"
                  htmlType="submit"
                  loading={isWalletLoading}
                  // onClick={() => setAddedWallet(true)}
                >
                  Submit
                </Button>
              </div>
            </Form>
          )}
        </>
      ) : (
        <>
          {getSingleWalletIsLoading ? (
            <Loader />
          ) : (
            <Form
              name="form_item_path"
              className="custom-form"
              layout="vertical"
              onFinish={onFinish}
              requiredMark="optional"
              size="large"
              form={form}
            >
              {/* <Form.Item
                label="Tags"
                name="tag_ids"
                rules={[
                  {
                    required: true,
                    message: "Please enter a tags",
                  },
                ]}
              >
                <Select
                  mode="tags"
                  placeholder="Tags"
                  tokenSeparators={[","]}
                  style={{ width: "100%" }}
                  options={getAllWalletTagData?.data?.tags?.map(
                    (item: any) => ({
                      label: item.name,
                      value: item.id,
                    })
                  )}
                  disabled={isApprover === "approver"}
                  allowClear
                />
              </Form.Item> */}

              <Form.Item
                label="Wallet Name"
                name="wallet_name"
                rules={[
                  {
                    required: true,
                    message: "Please enter a wallet name",
                  },
                ]}
              >
                <Input
                  placeholder="Wallet Name"
                  disabled={isApprover === "approver"}
                />
              </Form.Item>

              <Form.Item
                label="Wallet Number"
                name="wallet_number"
                rules={[
                  { required: true, message: "Please enter a wallet number" },
                  { validator: validateMobileBankAccount },
                ]}
                normalize={normalizeMobileBankAccount}
              >
                <Input
                  placeholder="015XXXXXX61"
                  disabled={isApprover === "approver"}
                />
              </Form.Item>
              <div className="flex justify-center mt-2">
                <Button
                  type="primary"
                  className="min-w-36"
                  htmlType="submit"
                  loading={isLoading}
                >
                  {type === "ADD" ? "Submit" : "Update"}
                </Button>
              </div>
            </Form>
          )}
        </>
      )}
    </CustomModal>
  );
}
